<template>
  <section class="travel-quote-info">
    <h2>Policy Detail</h2>
    <working-quote-info :formData="formData"></working-quote-info>
  </section>
</template>

<script>
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
export default {
  name: 'quote-refer-info',
  components: {WorkingQuoteInfo},
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>

</style>